import { Accordion, Divider, SimpleGrid, Stack, Text } from '@mantine/core';
import {
    createPayoutCascadesUrl,
    formatOrder,
    payoutOrderCascadeEventTypes,
    type PayoutCascadeAttempt,
} from '~/entities/payout';
import { KeyValuePair } from '~/shared/ui/KeyValuePair';
import { getAttemptKey, getAttemptValue, getCascadeFilterValue, getEntityLabel, getGroupKey } from '../utils';
import { CascadeGroupCard } from './CascadeGroupCard';
import { CascadePathLink } from './CascadePathLink';

interface CascadeAttemptProps {
    attempt: PayoutCascadeAttempt;
    index: number;
}

export const CascadeAttempt = ({ attempt, index }: CascadeAttemptProps) => {
    const cascadeFilterValue = getCascadeFilterValue(
        attempt.cascadeMatched?.cascadeName?.value,
        attempt.cascadeMatched?.cascadeId,
    );

    return (
        <Accordion.Item
            key={getAttemptKey(attempt)}
            value={getAttemptKey(attempt)}
        >
            <Accordion.Control>
                <SimpleGrid
                    cols={{ base: 1, sm: 3 }}
                    spacing='md'
                    verticalSpacing='xs'
                    w='100%'
                >
                    <KeyValuePair
                        label='Попытки'
                        value={getAttemptValue(attempt, index)}
                    />

                    {attempt.createdAt && (
                        <KeyValuePair
                            label='Дата'
                            value={formatOrder.date(attempt.createdAt)}
                        />
                    )}

                    {attempt.type && (
                        <KeyValuePair
                            label='Статус'
                            value={payoutOrderCascadeEventTypes[attempt.type]}
                        />
                    )}
                </SimpleGrid>
            </Accordion.Control>

            <Accordion.Panel>
                <Stack gap='sm'>
                    {attempt.cascadeMatched && cascadeFilterValue && (
                        <KeyValuePair
                            label='Каскад'
                            value={
                                <CascadePathLink
                                    label={getEntityLabel(
                                        attempt.cascadeMatched.cascadeName?.value,
                                        attempt.cascadeMatched.cascadeId,
                                        'Каскад',
                                    )}
                                    href={createPayoutCascadesUrl('cascades', { name: cascadeFilterValue })}
                                />
                            }
                        />
                    )}

                    {attempt.noCascadeMatched && (
                        <Text
                            size='sm'
                            c='dimmed'
                        >
                            Подходящий каскад не найден
                        </Text>
                    )}

                    {!!attempt.groups?.length && (
                        <>
                            <Divider label='Группы' />

                            <Stack gap='md'>
                                {attempt.groups.map((group, groupIndex) => (
                                    <CascadeGroupCard
                                        key={getGroupKey(group)}
                                        group={group}
                                        groupIndex={groupIndex}
                                    />
                                ))}
                            </Stack>
                        </>
                    )}
                </Stack>
            </Accordion.Panel>
        </Accordion.Item>
    );
};
